module.exports = [{"name":"Bericht verzenden","icon":"edit","link":"/admin/message"},{"name":"Uitloggen","icon":"home","link":"/admin/logout"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/MenuItems/adminMenuItems.json
// module id = 953
// module chunks = 0